import { render, staticRenderFns } from "./Prdtype_mgt.vue?vue&type=template&id=4d5f75e3&scoped=true"
import script from "./Prdtype_mgt.vue?vue&type=script&lang=js"
export * from "./Prdtype_mgt.vue?vue&type=script&lang=js"
import style0 from "./Prdtype_mgt.vue?vue&type=style&index=0&id=4d5f75e3&prod&lang=scss&scoped=true"
import style1 from "./Prdtype_mgt.vue?vue&type=style&index=1&id=4d5f75e3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5f75e3",
  null
  
)

export default component.exports